"use strict";
exports.__esModule = true;
var angular = require("angular");
var filter_logic_1 = require("../../report-options2/filter-logic");
var tree_filter_1 = require("../app/js/logic/tree-filter");
var project_category_assignment_logic_1 = require("../../../action/project-category-assignment/project-category-assignment.logic");
var add_node_modal_logic_1 = require("./add-node-modal.logic");
var COMPONENT_NAME = 'smartorg.r6.navs.addNode';
var AddNodeModalComponent = /** @class */ (function () {
    function AddNodeModalComponent($scope, $timeout) {
        var ctrl = this;
        ctrl.$timeout = $timeout;
        $scope.$on('addNodeModal', function () {
            add_node_modal_logic_1.assignDefaultEntries(ctrl.selected, ctrl.defaultCategories);
            ctrl.setToDefault();
        });
    }
    AddNodeModalComponent.prototype.$onChanges = function (changes) {
        var ctrl = this;
        if (changes.defaultReportOptions ||
            changes.defaultTreeViewFilters ||
            changes.selected) {
            ctrl.onSetupModal();
        }
        if (changes.actionType || changes.selected || changes.treeObj) {
            if (ctrl.actionType == "edit") {
                add_node_modal_logic_1.assignDefaultEntries(ctrl.selected, ctrl.defaultCategories);
                ctrl.setToDefault();
            }
            else if (this.actionType == "add") {
                ctrl.nodeName = '';
                add_node_modal_logic_1.cleanSelectedEntries(ctrl.defaultCategories);
            }
        }
    };
    AddNodeModalComponent.prototype.addSelectedTemplateToList = function () {
        if (this.templateName &&
            this.selectedTemplates.indexOf(this.templateName) < 0) {
            this.selectedTemplates.push(this.templateName);
            this.templateName = "";
        }
    };
    ;
    AddNodeModalComponent.prototype.removeTemplateFromList = function (template) {
        var index = this.selectedTemplates.indexOf(template);
        if (index > -1) {
            this.selectedTemplates.splice(index, 1);
        }
    };
    ;
    AddNodeModalComponent.prototype.replaceInvalidChars = function () {
        this.nodeName = this.nodeName.replace(/['"]/g, '');
    };
    ;
    AddNodeModalComponent.prototype.getParentTags = function (node, newNodeTags) {
        var ctrl = this;
        var tags = node['tags'];
        var tagsPropagatedUp = tags.concat(newNodeTags.filter(function (item) {
            return tags.indexOf(item) < 0;
        }));
        ctrl.parentTags.push([node['_id'], tagsPropagatedUp.toString()]);
        if (node['parent']) {
            this.getParentTags(node['parent'], ctrl.parentTags);
        }
    };
    AddNodeModalComponent.prototype.addSubnode = function () {
        this.tryToSubmit = true;
        this.addSelectedTemplateToList();
        if (this.nodeName && this.selectedTemplates.length > 0) {
            if (!this.treeObj.addNodeNameCheck(this.selected._id, this.nodeName)) {
                var showAlertDetails = {
                    "type": "danger",
                    "title": "Duplicate Node Name",
                    "message": "Invalid node name, duplicated child node name."
                };
                this.addNodeModalShowAlert({ alertDetails: showAlertDetails });
            }
            else {
                this.parentTags = [];
                var newNodeTags = add_node_modal_logic_1.getNewNodeTags(this.defaultCategories);
                this.getParentTags(this.selected, newNodeTags);
                var addNodeDetails = {
                    parentNodeId: this.selected._id,
                    newNodeName: this.nodeName,
                    templateName: this.selectedTemplates.join(),
                    platformOrLeaf: this.platformOrLeaf,
                    parentTags: this.parentTags,
                    newNodeTags: newNodeTags
                };
                this.onAddNode({ addNodeDetails: addNodeDetails });
                $("#addNodeModal").modal("hide");
                this.resetModal();
            }
        }
    };
    ;
    AddNodeModalComponent.prototype.addToDefaultCategoryNames = function (keyType, defaultCategoryNames) {
        if (keyType in this.defaultReportOptions &&
            defaultCategoryNames.indexOf(this.defaultReportOptions[keyType]) == -1) {
            defaultCategoryNames.push(this.defaultReportOptions[keyType]);
        }
    };
    ;
    AddNodeModalComponent.prototype.addFilterCategoryToDefaultCategoryNames = function (defaultLogic, defaultCategoryNames) {
        if ('filterLogic' in defaultLogic) {
            var filterLogic = filter_logic_1.createFilterLogic(defaultLogic['filterLogic']);
            var filterList = tree_filter_1.parseSimpleFilterFromString(filterLogic);
            for (var i = 0; filterList && i < filterList.length; i++) {
                if (defaultCategoryNames.indexOf(filterList[i]['name']) == -1) {
                    defaultCategoryNames.push(filterList[i]['name']);
                }
            }
        }
    };
    ;
    AddNodeModalComponent.prototype.setToDefault = function () {
        var ctrl = this;
        ctrl.originalDefaultCategories = angular.copy(ctrl.defaultCategories);
        ctrl.templateName = ctrl.templateName ? ctrl.templateName : "";
        ctrl.originalTemplateName = angular.copy(ctrl.templateName);
        ctrl.editSave = false;
    };
    AddNodeModalComponent.prototype.updateSelectedNode = function (tagsData) {
        var ctrl = this;
        tagsData.forEach(function (tag) {
            var nodeID = tag[0];
            if (nodeID == ctrl.selected._id) {
                var tagString = tag[1];
                var tags = tagString.split(",");
                ctrl.selected.tagString = tagString;
                ctrl.selected.tags = tags;
            }
        });
    };
    AddNodeModalComponent.prototype.showDefaultCategories = function () {
        return this.defaultCategories && this.defaultCategories.length > 0 &&
            (this.actionType == "add" || (this.actionType == "edit" &&
                this.selected && !this.selected.hasChildren));
    };
    AddNodeModalComponent.prototype.onSetupModal = function () {
        this.defaultCategories = [];
        var defaultCategoryNames = [];
        this.platformOrLeaf = "leaf";
        if (this.defaultReportOptions &&
            Object.keys(this.defaultReportOptions).length !== 0) {
            this.addToDefaultCategoryNames('groupKey', defaultCategoryNames);
            this.addToDefaultCategoryNames('colorKey', defaultCategoryNames);
            this.addFilterCategoryToDefaultCategoryNames(this.defaultReportOptions, defaultCategoryNames);
        }
        if (this.defaultTreeViewFilters &&
            Object.keys(this.defaultTreeViewFilters).length !== 0) {
            this.addFilterCategoryToDefaultCategoryNames(this.defaultTreeViewFilters, defaultCategoryNames);
        }
        if (this.treeObj && this.treeObj.categoriesConfig) {
            this.defaultCategories = angular.copy(this.treeObj['categoriesConfig']).filter(function (categoryData) {
                return defaultCategoryNames.indexOf(categoryData['CategoryName']) !== -1;
            });
        }
        this.originalDefaultCategories = angular.copy(this.defaultCategories);
    };
    AddNodeModalComponent.prototype.resetModal = function () {
        this.nodeName = "";
        this.templateName = "";
        this.selectedTemplates = [];
        this.platformOrLeaf = "leaf";
        this.tryToSubmit = false;
        this.defaultCategories = angular.copy(this.originalDefaultCategories);
        this.templateName = angular.copy(this.originalTemplateName);
        this.editSave = false;
    };
    AddNodeModalComponent.prototype.compareDefaultCategories = function () {
        var ctrl = this;
        ctrl.editSave = false;
        if (ctrl.actionType == "edit") {
            ctrl.defaultCategories.forEach(function (cat, index) {
                if ('selectedEntry' in cat &&
                    ((!ctrl.originalDefaultCategories[index]['selectedEntry']) ||
                        (cat['selectedEntry'] !== ctrl.originalDefaultCategories[index]['selectedEntry']))) {
                    ctrl.editSave = true;
                }
            });
        }
    };
    AddNodeModalComponent.prototype.compareTemplateName = function () {
        var ctrl = this;
        ctrl.editSave = ctrl.originalTemplateName != ctrl.templateName;
    };
    /**
     * This function is almost identical to addSubnode. Maybe we
     * should combine them.
     */
    AddNodeModalComponent.prototype.editNode = function () {
        this.tryToSubmit = true;
        this.addSelectedTemplateToList();
        if (this.nodeName && (this.selectedTemplates.length > 0
            || this.actionType === 'edit')) {
            if (!this.treeObj.editNodeNameCheck(this.selected._id, this.nodeName)) {
                var showAlertDetails = {
                    "type": "danger",
                    "title": "Duplicate Node Name",
                    "message": "Cannot have duplicate name on same level."
                };
                this.addNodeModalShowAlert({ alertDetails: showAlertDetails });
            }
            else {
                var saveTagsData = this.selected.children.length > 0 ? [] :
                    project_category_assignment_logic_1.generateTagsData(this.selected, this.selected.tags, this.defaultCategories);
                var editNodeDetails = {
                    nodeId: this.selected._id,
                    newNodeName: this.nodeName,
                    templateName: this.selectedTemplates.join(),
                    children: [],
                    saveTags: saveTagsData
                };
                this.onEditNode({ editNodeDetails: editNodeDetails });
                this.originalDefaultCategories = angular.copy(this.defaultCategories);
                this.originalTemplateName = angular.copy(this.templateName);
                this.editSave = false;
                $("#addNodeModal").modal("hide");
                this.updateSelectedNode(saveTagsData);
                add_node_modal_logic_1.assignDefaultEntries(this.selected, this.defaultCategories);
                this.setToDefault();
                this.resetModal();
            }
        }
    };
    ;
    return AddNodeModalComponent;
}());
exports.AddNodeModalComponent = AddNodeModalComponent;
angular.module(COMPONENT_NAME, []).component('addNodeModal', {
    template: require('./add-node-modal.component.html'),
    bindings: {
        modalId: '@',
        actionType: '<',
        selected: '<',
        selectedTemplates: '=',
        templateName: '<',
        nodeName: '=',
        addNodeModalShowAlert: '&?',
        treeObj: '<',
        treeName: '<',
        defaultCategories: '=',
        defaultReportOptions: '<',
        defaultTreeViewFilters: '<',
        onAddNode: '&',
        onEditNode: '&'
    },
    controller: AddNodeModalComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=add-node-modal.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/add-node-modal/add-node-modal.component.js